import type { Translations } from '../../../types'

const profilePreferencesMessages: Translations = {
  "profile.preferences.sectionTitle": "Preferenze",
  "profile.preferences.sectionSubtitle": "Personalizza lingua, fuso orario e notifiche del tuo account.",
  "profile.preferences.heroTitle": "Profilo e localizzazione",
  "profile.preferences.heroSubtitle": "Imposta lingua, fuso orario e il tipo di alert che vuoi ricevere.",
  "profile.preferences.summary.language": "Lingua attuale",
  "profile.preferences.summary.timezone": "Fuso orario",
  "profile.preferences.summary.notifications": "Notifiche",
  "profile.preferences.summary.notificationsActive": "{{count}} attive",
  "profile.preferences.summary.security": "Alert di sicurezza",
  "profile.preferences.interfaceCard.title": "Impostazioni interfaccia",
  "profile.preferences.interfaceCard.subtitle": "Mantieni lingua e orari coerenti in tutto il pannello admin.",
  "profile.preferences.languageTitle": "Lingua e notifiche",
  "profile.preferences.languageSubtitle": "Imposta fuso orario, lingua e alert di prodotto/marketing.",
  "profile.preferences.timezoneLabel": "Fuso orario",
  "profile.preferences.timezoneSearchPlaceholder": "Cerca fuso orario",
  "profile.preferences.timezoneSearchEmpty": "Nessun fuso orario trovato",
  "profile.preferences.interfaceLanguageLabel": "Lingua interfaccia",
  "profile.preferences.notificationLabel": "Preferenze notifiche",
  "profile.preferences.notifications.product": "Aggiornamenti prodotto",
  "profile.preferences.notifications.product.description": "Nuovi eventi prodotto, aggiornamenti stock e variazioni catalogo.",
  "profile.preferences.notifications.marketing": "Promozioni / marketing",
  "profile.preferences.notifications.marketing.description": "Lanci campagne, iniziative promozionali e aggiornamenti growth.",
  "profile.preferences.notifications.security": "Alert di sicurezza",
  "profile.preferences.notifications.security.description": "Alert critici di accesso e protezione account per il backoffice.",
  "profile.preferences.notifications.securityPriority": "Le notifiche di sicurezza restano prioritarie",
  "profile.preferences.snapshot": "Riepilogo",
  "profile.preferences.save": "Salva preferenze",
  "profile.preferences.saving": "Salvataggio...",
  "profile.preferences.localeHelper": "Scegli la lingua preferita per il back office.",
  "profile.preferences.localeEmpty": "Nessuna lingua aggiuntiva disponibile.",
  "profile.preferences.timezoneHelper": "Mostra date e orari nel tuo fuso orario.",
  "profile.preferences.notificationsHelper": "Alert inviati solo per ciò che è importante per te.",
  "profile.preferences.actionBar.title": "Pronto ad applicare le modifiche?",
  "profile.preferences.actionBar.subtitle": "Salva ora per aggiornare lingua, fuso orario e notifiche del tuo account.",
  "profile.preferences.actionBar.unsaved": "Modifiche non salvate",
  "profile.preferences.smtp.title": "Configurazione SMTP runtime",
  "profile.preferences.smtp.description": "Configura il canale SMTP operativo del sistema.",
  "profile.preferences.smtp.pageTitle": "Configurazione email",
  "profile.preferences.smtp.pageDescription": "Definisci come il sistema invia le email operative e monitora lo stato degli invii.",
  "profile.preferences.smtp.statusBlockTitle": "Stato invio email",
  "profile.preferences.smtp.statusBlockDescription": "Attiva/disattiva gli invii e configura mittente e reply-to.",
  "profile.preferences.smtp.smtpBlockTitle": "Configurazione SMTP",
  "profile.preferences.smtp.smtpBlockDescription": "Parametri tecnici del provider SMTP e credenziali di autenticazione.",
  "profile.preferences.smtp.diagnosticsTitle": "Stato e diagnostica",
  "profile.preferences.smtp.diagnosticsDescription": "Controlla ultimo test SMTP e storico invii recenti.",
  "profile.preferences.smtp.refresh": "Aggiorna stato",
  "profile.preferences.smtp.enabled": "Email abilitate",
  "profile.preferences.smtp.dryRun": "Modalita dry-run",
  "profile.preferences.smtp.from": "Mittente di default",
  "profile.preferences.smtp.defaultFromName": "Nome mittente di default",
  "profile.preferences.smtp.defaultFromEmail": "Email mittente di default",
  "profile.preferences.smtp.replyTo": "Reply-To (opzionale)",
  "profile.preferences.smtp.replyToPlaceholder": "supporto@azienda.it",
  "profile.preferences.smtp.provider": "Provider email",
  "profile.preferences.smtp.provider.gmail": "Gmail",
  "profile.preferences.smtp.provider.outlook": "Outlook",
  "profile.preferences.smtp.provider.custom": "SMTP personalizzato",
  "profile.preferences.smtp.providerHint.gmail": "Gmail richiede una password per app se e attiva l'autenticazione a due fattori.",
  "profile.preferences.smtp.providerHint.outlook": "Per Outlook/Microsoft 365 verifica che SMTP AUTH sia abilitato per l'account.",
  "profile.preferences.smtp.host": "SMTP host",
  "profile.preferences.smtp.port": "SMTP porta",
  "profile.preferences.smtp.secure": "Connessione sicura",
  "profile.preferences.smtp.user": "SMTP username",
  "profile.preferences.smtp.password": "SMTP password",
  "profile.preferences.smtp.passwordStored": "Password gia configurata",
  "profile.preferences.smtp.passwordHint": "Lascia vuoto per mantenere la password corrente.",
  "profile.preferences.smtp.clearPassword": "Rimuovi password salvata",
  "profile.preferences.smtp.save": "Salva configurazione",
  "profile.preferences.smtp.saving": "Salvataggio configurazione...",
  "profile.preferences.smtp.saved": "Configurazione email aggiornata",
  "profile.preferences.smtp.sendTest": "Invia email di test",
  "profile.preferences.smtp.testing": "Invio test...",
  "profile.preferences.smtp.testSuccess": "Test SMTP completato con successo",
  "profile.preferences.smtp.testError": "Test SMTP non riuscito",
  "profile.preferences.smtp.loading": "Caricamento configurazione email...",
  "profile.preferences.smtp.note": "Le credenziali SMTP sono cifrate lato backend e modificabili con la capability manage_email_settings.",
  "profile.preferences.smtp.loadError": "Errore caricamento configurazione email",
  "profile.preferences.smtp.saveError": "Errore salvataggio configurazione email",
  "profile.preferences.smtp.loginRequired": "Login richiesto per aggiornare la configurazione email",
  "profile.preferences.smtp.readOnlyNotice": "Serve la capability manage_email_settings per modificare questa configurazione. Stai visualizzando una versione in sola lettura.",
  "profile.preferences.smtp.summary.configured": "SMTP configurato",
  "profile.preferences.smtp.summary.notConfigured": "SMTP non configurato",
  "profile.preferences.smtp.summary.testSuccess": "Ultimo test riuscito",
  "profile.preferences.smtp.summary.testFailed": "Ultimo test fallito",
  "profile.preferences.smtp.summary.testNever": "Test mai eseguito",
  "profile.preferences.smtp.summary.dryRunOn": "Dry-run attivo",
  "profile.preferences.smtp.summary.dryRunOff": "Dry-run disattivo",
  "profile.preferences.smtp.summary.lastTestAt": "Ultimo test",
  "profile.preferences.smtp.summary.password": "Stato password",
  "profile.preferences.smtp.summary.passwordConfigured": "Password configurata",
  "profile.preferences.smtp.summary.passwordMissing": "Password non configurata",
  "profile.preferences.smtp.summary.passwordMissingHint": "Nessuna password salvata per l'autenticazione SMTP",
  "profile.preferences.smtp.summary.passwordPendingRemoval": "Password verra rimossa al salvataggio",
  "profile.preferences.smtp.summary.lastError": "Ultimo errore",
  "profile.preferences.smtp.alert.emailDisabled": "Le email di sistema sono attualmente disabilitate.",
  "profile.preferences.smtp.alert.dryRunEnabled": "La modalita dry-run e attiva: gli invii verranno simulati e non recapitati.",
  "profile.preferences.smtp.alert.incompleteConfig": "Configurazione SMTP incompleta: verifica host, username e password.",
  "profile.preferences.smtp.alert.lastTestFailed": "L'ultimo test SMTP e fallito. Controlla i parametri e riprova.",
  "profile.preferences.smtp.alert.passwordRemovalPending": "Hai selezionato la rimozione della password salvata. Salva per confermare.",
  "profile.preferences.smtp.logs.loadError": "Errore caricamento log email",
  "profile.preferences.smtp.logs.loading": "Caricamento log email...",
  "profile.preferences.smtp.logs.empty": "Nessun log disponibile al momento.",
  "profile.preferences.smtp.logs.columns.date": "Data/Ora",
  "profile.preferences.smtp.logs.columns.event": "Evento",
  "profile.preferences.smtp.logs.columns.recipient": "Destinatario",
  "profile.preferences.smtp.logs.columns.status": "Stato",
  "profile.preferences.smtp.logs.columns.error": "Errore",
  "profile.preferences.smtp.logs.status.sent": "Inviato",
  "profile.preferences.smtp.logs.status.dryRun": "Simulato",
  "profile.preferences.smtp.logs.status.failed": "Fallito",
}

export default profilePreferencesMessages
